import React, {Component} from 'react';
import '../comCss/Poke.css';
import CodeBlock from '../CodeBlock';

export class VimoMeny extends Component {

    constructor(props) {
      super(props);
      this.state = {isToggleOn: true};
    
      // This binding is necessary to make `this` work in the callback
      this.handleClick = this.handleClick.bind(this);
    }

    handleClick() {
        this.setState(state => ({
          isToggleOn: !state.isToggleOn
        }));
      }

    render(){ 
   return (
    <div class="mobile-meny" onClick={this.handleClick}>
            <div class="top-meny" style={this.state.isToggleOn ? {animation: 'topMeny-close-ani 0.5s both'} : {animation: 'topMeny-ani 0.5s both'} }></div>
            <div class="middle-meny" style={this.state.isToggleOn ? {animation: 'midMeny-close-ani 0.5s both'} : {animation: 'midMeny-ani 0.25s 0.25s both'}}></div>
            <div class="bottom-meny"style={this.state.isToggleOn ? {animation: 'btmMeny-close-ani 0.5s both'} : {animation: 'btmMeny-ani 0.5s both'}}></div>
        </div>
   );
 }
 }

 export class VimoCom extends Component {

   render(){ 
    const a = <VimoMeny />
    const js = `
    export class VimoMeny extends Component {

        constructor(props) {
          super(props);
          this.state = {isToggleOn: true};
        
          // This binding is necessary to make "this" work in the callback
          this.handleClick = this.handleClick.bind(this);
        }
    
        handleClick() {
            this.setState(state => ({
              isToggleOn: !state.isToggleOn
            }));
          }
    
        render(){ 
       return (
        <div class="mobile-meny" onClick={this.handleClick}>
                <div class="top-meny" style={this.state.isToggleOn ? {animation: 'topMeny-close-ani 0.5s both'} : {animation: 'topMeny-ani 0.5s both'} }></div>
                <div class="middle-meny" style={this.state.isToggleOn ? {animation: 'midMeny-close-ani 0.5s both'} : {animation: 'midMeny-ani 0.25s 0.25s both'}}></div>
                <div class="bottom-meny"style={this.state.isToggleOn ? {animation: 'btmMeny-close-ani 0.5s both'} : {animation: 'btmMeny-ani 0.5s both'}}></div>
            </div>
       );
     }
     }`

  return (
    <div class="project-view-section-2">
            <div>
                <h3 class="hs2-recent-tit">Recent UI</h3>
                <img src={process.env.PUBLIC_URL + "/images/Projects/Vimo/1.jpg"} class="pws1-poke-imgs" />
            </div>

            <div>
                <p class="pws1-pro-descript">Here is a little demo for the menu I made. You can find the website through this <a href="https://www.vimomedia.com" style={{color: "#2771A6"}}>link.</a></p>
                < CodeBlock 
                code = "javascript"
                lang = "React"
                title = "Meny animation"
                playground = {a}
                js = {js}
                css = "last"
                bgColor = "#CDDDBD"
                />
            </div>

            <div>
                <h3 class="hs2-recent-tit">Clients UI</h3>
                <img src={process.env.PUBLIC_URL + "/images/Projects/Vimo/2.jpg"} class="pws1-poke-imgs"/>
            </div>

            <div>
                <h3 class="hs2-recent-tit">About UI</h3>
                <img src={process.env.PUBLIC_URL + "/images/Projects/Vimo/3.jpg"} class="pws1-poke-imgs"/>
            </div>
    </div>
  );
}
}


export default VimoCom;
